export default {
    /**
     * Convert image url to objectFile
     */
    async urlToObjFile(url = "", fileName = "") {
        const response = await fetch(url);
        const data = await response.blob();
        const metadata = {
            type: "image/jpeg",
        };
        const file = new File([data], fileName, metadata);
        return file;
    },
    /**
     * Converts Base64 to objectFile
     */
    async getFileFromBase64(string64 = "", fileName = "dummy-name") {
        // console.log("string64", string64);
        // const trimmedString = string64.replace("dataimage/jpegbase64", "");
        // const imageContent = atob(trimmedString);
        const imageContent = atob(string64);
        // const imageContent = Buffer.from(string64, "base64");
        const buffer = new ArrayBuffer(imageContent.length);
        const view = new Uint8Array(buffer);

        for (let n = 0; n < imageContent.length; n++) {
            view[n] = imageContent.charCodeAt(n);
        }
        const type = "image/jpeg";
        const blob = new Blob([buffer], { type });
        return new File([blob], fileName, {
            lastModified: new Date().getTime(),
            type,
        });
    },
};
